<template>
  <!-- :bodyStyle="{paddingTop:'10px'}" -->
  <a-card :bordered="false" :headStyle="{borderBottom:'0px',fontSize:'18px',paddingLeft:'24px'}">
    <search-page-view
      ref="table"
      rowKey="ruleId"
      :columns="columns"
      :enableSearch="false"
      :queryParams="queryParams"
      :requestPromise="loadPromise"
    >
      <a-form-item slot="operation">
        <a-input-search placeholder="请输入规则名称" @search="onSearch" style="max-width: 400px;"/>
        <a-button style="margin-left: 10px" type="primary" icon="plus" @click="createCodeEvent(0)">新建</a-button>
      </a-form-item>
      <div slot="action" slot-scope="data">
        <a @click="createCodeEvent(data.record.ruleId,data.record.status)">查看</a>
      </div>
    </search-page-view>
  </a-card>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'CouponRuleList',
  data() {
    return {
      submitLoading: false,
      queryParams: {
        ruleName: '', // 规则名称
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId
      },
      loadPromise: params => this.getListPromise(params),
      columns: [
        {
          title: 'ID',
          dataIndex: 'ruleId'
        },
        {
          title: '规则名称',
          dataIndex: 'ruleName'
        },
        {
          title: '关联优惠券',
          dataIndex: 'couponName'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime'
        },
        {
          title: '状态',
          dataIndex: 'statusStr'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '180px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    }
  },
  computed: {
    ...mapState({
      // 获取版本
      vesion: state => state.config.serverDataInfo.vesion
    })
  },
  mounted() {

  },
  activated() {
    this.getLogUtils().logWithTag('优惠券activated')
    this.$store.commit('SET_RECHARGE', true)
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'CouponServiceList', title: '优惠券列表' },
      { name: 'CouponRuleList', title: '规则列表' }
    ])
    if (this.$route.query.updateFlag) {
      this.getLogUtils().logWithTag('activated', this.$route.query.updateFlag)
      this.$refs.table.refresh(true)
    }
  },
  methods: {
    onSearch(value) {
      this.queryParams.ruleName = value
      this.$refs.table.refresh(true)
    },
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getOrderListPromise==', params)
      return this.getHttpServices().getServerApiService().post('couponSettingRule/getCouponRuleList', params)
    },
    // 新增内容
    createCodeEvent(ruleId, status) {
      this.$router.push({
        name: 'NewRule',
        query: {
          ruleId: ruleId,
          status: status,
          serverUniqueId: this.$route.query.serverUniqueId
        }
      })
    }
  }

}
</script>
<style scoped lang="less">

</style>